import { render } from "./Boutiques.vue?vue&type=template&id=20f3d76e"
import script from "./Boutiques.vue?vue&type=script&lang=js"
export * from "./Boutiques.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__